module.exports = __webpack_public_path__ + "static/img/downmt4.8252493.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/index/img/downmt4.jpg
// module id = 4+Yg
// module chunks = 1